'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { cloneElement, forwardRef, isValidElement } from 'react';
import { cn } from '../../utils/cn';
export const NavbarItem = forwardRef(({ children, className, active, asChild, ...props }, ref) => {
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            itemRef: ref,
            ...props,
        });
    }
    return (_jsx("div", { ...props, className: cn('cursor-pointer rounded-md bg-transparent px-4 py-2 text-body-4 font-medium transition-all duration-300 active:scale-95', active
            ? 'bg-primary-500 text-white hover:bg-primary-600 dark:bg-primary-500 dark:text-white dark:hover:bg-primary-600'
            : 'text-metal-600 hover:bg-metal-50 hover:text-metal-900 dark:text-white dark:hover:bg-primary-600 dark:hover:text-white', className), ref: ref, children: children }));
});
NavbarItem.displayName = 'NavbarItem';
